import { alpha } from '@mui/material/styles';

/** Design tokens — Architectural Monolith glass (no solid 1px borders; blur + tonal layers) */
const SURFACE_RGB = '247, 249, 251';
const ON_SURFACE = '#191c1e';
const PRIMARY_NAVY = '#00081e';

export interface GlassVariant {
  background: string;
  border: string;
  backdropFilter: string;
  boxShadow: string;
  hoverBackground?: string;
  hoverBoxShadow?: string;
}

export const glassVariants = {
  subtle: {
    background: `rgba(${SURFACE_RGB}, 0.45)`,
    border: 'none',
    backdropFilter: 'blur(12px)',
    boxShadow: `0 4px 24px ${alpha(ON_SURFACE, 0.04)}`,
    hoverBackground: `rgba(${SURFACE_RGB}, 0.55)`,
    hoverBoxShadow: `0 6px 28px ${alpha(ON_SURFACE, 0.06)}`,
  },
  medium: {
    background: `rgba(${SURFACE_RGB}, 0.6)`,
    border: 'none',
    backdropFilter: 'blur(20px)',
    boxShadow: `0 8px 32px ${alpha(ON_SURFACE, 0.04)}`,
    hoverBackground: `rgba(${SURFACE_RGB}, 0.72)`,
    hoverBoxShadow: `0 10px 40px ${alpha(ON_SURFACE, 0.06)}`,
  },
  bold: {
    background: `linear-gradient(135deg, ${alpha(
      PRIMARY_NAVY,
      0.08
    )} 0%, rgba(${SURFACE_RGB}, 0.65) 100%)`,
    border: 'none',
    backdropFilter: 'blur(20px)',
    boxShadow: `0 12px 48px ${alpha(ON_SURFACE, 0.06)}`,
    hoverBackground: `linear-gradient(135deg, ${alpha(
      PRIMARY_NAVY,
      0.12
    )} 0%, rgba(${SURFACE_RGB}, 0.75) 100%)`,
    hoverBoxShadow: `0 14px 52px ${alpha(ON_SURFACE, 0.08)}`,
  },
} as const;

export const glassElevations = {
  0: '0px',
  1: '2px',
  2: '4px',
  3: '8px',
  4: '12px',
  5: '16px',
} as const;

export const glassTransitions = {
  smooth: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  bounce: 'all 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
  elastic: 'all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
} as const;

export const glassAnimations = {
  fadeIn: {
    from: { opacity: 0, transform: 'translateY(20px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
  },
  slideIn: {
    from: { opacity: 0, transform: 'translateX(-20px)' },
    to: { opacity: 1, transform: 'translateX(0)' },
  },
  scaleIn: {
    from: { opacity: 0, transform: 'scale(0.95)' },
    to: { opacity: 1, transform: 'scale(1)' },
  },
} as const;

export type GlassVariantKey = keyof typeof glassVariants;
export type GlassElevationKey = keyof typeof glassElevations;
export type GlassTransitionKey = keyof typeof glassTransitions;
